interface CommonCarouselItemFields {
  /**
   * A random string that uniquely identifies the item in a carousel.
   * It's optional for single images for historical reasons, but it's required when there are multiple images.
   */
  id?: string;
  caption?: string;
  /**
   * The preferred width for displaying the image.
   * This is only used for half spans, and ignored in other cases.
   */
  width?: number;
  /**
   * The natural dimensions of the image
   */
  natural?: { width: number; height: number };
}

export interface UploadedCarouselItem extends CommonCarouselItemFields {
  /**
   * The URL of the image. It doesn't include asset token.
   * In most cases, it points to our CDN. However, in case of failed uploads, it
   * can be a URL pointing to the original 3rd party source.
   */
  source: string;
}

export interface UploadingCarouselItem extends CommonCarouselItemFields {
  /**
   * The payload that will be uploaded. It can be a file or a URL.
   * When it's a URL, usually we use it for `uploadPreviewSource` as well.
   */
  uploadPayload: File | string;
  /**
   * A string that can be used as `src` for an `img` tag to show a preview of the image being uploaded.
   * It can be either an https URL or a data URL.
   */
  uploadPreviewSource?: string;
}

export type CarouselItem = UploadedCarouselItem | UploadingCarouselItem;

export const isUploadedCarouselItem = (
  item: CarouselItem,
): item is UploadedCarouselItem => {
  return 'source' in item;
};
